(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("js-cookie"));
	else if(typeof define === 'function' && define.amd)
		define([, , ], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("prop-types"), require("js-cookie")) : factory(root[undefined], root[undefined], root[undefined]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, (__WEBPACK_EXTERNAL_MODULE__5225__, __WEBPACK_EXTERNAL_MODULE__6073__, __WEBPACK_EXTERNAL_MODULE__4360__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 4360:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__4360__;

/***/ }),

/***/ 6073:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__6073__;

/***/ }),

/***/ 5225:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__5225__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ CookieMessage)
});

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react"}
var external_commonjs_react_commonjs2_react_ = __webpack_require__(5225);
var external_commonjs_react_commonjs2_react_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_react_commonjs2_react_);
// EXTERNAL MODULE: external {"commonjs":"prop-types","commonjs2":"prop-types"}
var external_commonjs_prop_types_commonjs2_prop_types_ = __webpack_require__(6073);
var external_commonjs_prop_types_commonjs2_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_prop_types_commonjs2_prop_types_);
// EXTERNAL MODULE: external {"commonjs":"js-cookie","commonjs2":"js-cookie"}
var external_commonjs_js_cookie_commonjs2_js_cookie_ = __webpack_require__(4360);
var external_commonjs_js_cookie_commonjs2_js_cookie_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_js_cookie_commonjs2_js_cookie_);
;// CONCATENATED MODULE: ./src/core/url-base.js
var DEFAULT_URL_BASE = "";

var absUrl = function absUrl(path) {
  var urlBase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_URL_BASE;
  return "".concat(urlBase).concat(path);
};

/* harmony default export */ const url_base = (absUrl);
;// CONCATENATED MODULE: ./src/core/CookieMessage/component.jsx
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





var COOKIE_EXPIRY = 365;
function CookieMessage(_ref) {
  var cookieId = _ref.cookieId,
      urlBase = _ref.urlBase;
  var ref = (0,external_commonjs_react_commonjs2_react_.useRef)(null);

  var _useState = (0,external_commonjs_react_commonjs2_react_.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      hideCookieMessage = _useState2[0],
      setHideCookieMessage = _useState2[1];

  (0,external_commonjs_react_commonjs2_react_.useEffect)(function () {
    var isCookieSet = external_commonjs_js_cookie_commonjs2_js_cookie_default().get(cookieId) ? true : false;
    setHideCookieMessage(isCookieSet);
  }, []);

  var handleClose = function handleClose() {
    external_commonjs_js_cookie_commonjs2_js_cookie_default().set(cookieId, "1", {
      expires: COOKIE_EXPIRY
    });
    ref.current.classList.add("bottom-1", "opacity-0");
    setTimeout(function () {
      return setHideCookieMessage(true);
    }, 500);
  };

  var absUrl = function absUrl(path) {
    return url_base(path, urlBase);
  }; // Presume the message is hidden by default


  if (hideCookieMessage) return null;
  return /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "ui-cookie-message",
    ref: ref
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-text-p2 pr-32"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/privacy"),
    className: "underline"
  }, "How we use cookies"), " ", "to improve your experience."), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("button", {
    className: "ui-btn-secondary mt-12 sm:mt-0 whitespace-nowrap",
    onClick: handleClose
  }, "Accept and close"));
}
CookieMessage.propTypes = {
  cookieId: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
  urlBase: (external_commonjs_prop_types_commonjs2_prop_types_default()).string
};
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});